export default __webpack_public_path__ + "static/modulesSection-47d561e5db4d95b2ac6828cc1f40a6b5.gif";